import { Suspense, useEffect } from 'react'

import * as Sentry from '@sentry/react'

import GetBranchName from 'components/GetBranchName/GetBranchName'
import { AppConfigProvider } from 'Providers/AppConfigProvider'

import RootBoundary from './components/RootBoundary'
import Router from './Router'

import './i18n'
import './App.css'

import { Toaster } from '@/components/aural-ui/toast'
import GlobalLoading from '@/components/shared/GlobalLoading'
import { Toaster as ShadCnToaster } from '@/components/ui/toaster'

function App() {
  useEffect(() => {
    window.process = {
      ...window.process,
    }
  }, [])
  return (
    <div className="App">
      <Sentry.ErrorBoundary fallback={RootBoundary}>
        <Suspense fallback={<GlobalLoading />}>
          <AppConfigProvider>
            <Router />
            <GetBranchName />
            <Toaster />
            <ShadCnToaster />
          </AppConfigProvider>
        </Suspense>
      </Sentry.ErrorBoundary>
    </div>
  )
}

export default App
